module.exports = __webpack_public_path__ + "img/3.5a7431d4.jpg";